export default __webpack_public_path__ + "static/media/GF_FURY_Horizontal.3c1d5660.jpg";